import { z } from "zod";

export const serverResponse = z.array(
  z.object({
    postCode: z.string(),
  }),
);
